import { Span } from "@common";
import { Button, Modal } from "antd"; 

type Props = { 
    modalOpen: boolean
    clickEvent?: () => void
    cancelEvent?: () => void
    loading?: boolean
    okLabel?: string   
}

export const DeclinedModal = (props: Props) => {

  return (  
    <Modal 
      title="Manual Declined"
      open={props.modalOpen}
      onCancel={props.cancelEvent} 
      footer={[<>
        <Button onClick={props.cancelEvent} loading={props.loading}>
          Close
        </Button>

        <Button type="primary" danger onClick={props.clickEvent} loading={props.loading}>
            Decline
        </Button>
      </>]}  
    > 
      <p><Span>Are you sure you want to declined?</Span></p>     
    </Modal>
  );
}